module.exports = __webpack_public_path__ + "static/media/team-chilka.0b3a846b.jpg";